import React, {useMemo} from 'react';
import moment from 'moment';
import {useTable, usePagination, useFilters} from 'react-table';
import {Table} from 'semantic-ui-react';
import {Filter, DefaultColumnFilter} from '../../common/TableFilters';
import {shortDate} from '../../../../common/constants/datesFormat';
import DeleteIcon from '../../common/icons/DeleteIcon';
import TablePaginator from '../../common/TablePaginator';

const columnsTableWithProps = (isUserTde) => {
  const columns = [
    {
      'Header': 'MODELO',
      'accessor': 'modelName',
    },
    {
      'Header': 'CHASSIS',
      'accessor': 'chassis',
    },
    {
      'Header': 'KATASHIKI',
      'accessor': 'katashiki',
    },
    {
      'Header': 'FECHA FABRICACION',
      'accessor': 'createDate',
      'Cell': ({row}) => {
        const createDate = row.original && row.original.createDate;
        return moment(createDate).format(shortDate);
      },
    },
    {
      'Header': 'PARTE No 1',
      'accessor': 'partNo1',
    },
    {
      'Header': 'PARTE No 2',
      'accessor': 'partNo2',
    },
    {
      'Header': 'PARTE No 3',
      'accessor': 'partNo3',
    },
    {
      'Header': 'PARTE No 4',
      'accessor': 'partNo4',
    },
    {
      'Header': 'PARTE No 5',
      'accessor': 'partNo5',
    },
    {
      'Header': 'PARTE No 6',
      'accessor': 'partNo6',
    },
    {
      'Header': 'PARTE No 7',
      'accessor': 'partNo7',
    },
    {
      'Header': 'PARTE No 8',
      'accessor': 'partNo8',
    },
    {
      'Header': 'PARTE No 9',
      'accessor': 'partNo9',
    },
    {
      'Header': 'NOMBRE CLIENTE',
      'accessor': 'name',
    },
    {
      'Header': 'DOCUMENTO DEALER',
      'accessor': 'dealerDocument',
    },
    {
      'Header': 'NOMBRE DEALER',
      'accessor': 'dealerName',
      'Cell': ({row}) => row.original.dealerName.toUpperCase(),
    },
    {
      'Header': 'ESTADO',
      'accessor': 'state',
    },
    {
      'Header': 'CIUDAD',
      'accessor': 'city',
    },
    {
      'Header': 'TELEFONO',
      'accessor': 'conventionalPhone',
    },
    {
      'Header': 'CELULAR',
      'accessor': 'mobilePhone',
    },
    {
      'Header': 'CORREO ELECTRONICO',
      'accessor': 'email',
    },
  ];

  const isActionsInColumns = columns.some((header) => header.Header === 'ACCIONES');

  if (isUserTde && !isActionsInColumns) {
    columns.push({
      'Header': 'ACCIONES',
      'disableFilters': true,
      'Cell': ({row}) => {
        const {campaingNo, chassis} = row.original;
        return (
          <DeleteIcon index={row.index} data={chassis} dataType='chassis' campaingNo={campaingNo} />
        );
      },
    });
  }
  return columns;
};

const ModelsTable = ({dataTable, isUserTde}) => {
  const columnsTable = columnsTableWithProps(isUserTde);
  const data = useMemo(() => dataTable, []);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination,
  );

  return (
    <>
      <div className='table-container'>
        <Table
          className='interactive'
          striped
          {...getTableProps()}
        >
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign='center'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key='filters' id='filters'>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    textAlign='center'
                  >
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell, idx) => {
                      return (
                        <Table.Cell key={idx} textAlign='center'>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default ModelsTable;
